import React, { useState, useEffect } from 'react'
import { Modal, Dropdown } from "react-bootstrap";
import { toast } from 'react-toastify';
import html2pdf from 'html2pdf.js'
import moment from 'moment';
import 'react-toastify/dist/ReactToastify.css';
import "./warrantyclaim.css"


const WarrantyClaim = () => {
  const [searchvalue, setsearchvalue] = useState("")
  const [searchclaimvalue, setsearchclaimvalue] = useState("")
  const [modalWarrantyClaim1, setModalWarrantyClaim1] = useState(false);
  const [modalWarrantyClaim2, setModalWarrantyClaim2] = useState(false);
  const [warrantyIndex, setWarrantyIndex] = useState(0)
  const [warrantyDescription, setWarrantyDescription] = useState("")
  const [loader, setLoader] = useState(false)
  const [warranty, setwarranty] = useState([])
  const [originalWarranty, setoriginalWarranty] = useState([]) 
  const [warrantyClaim, setWarrantyClaim] = useState([])
  const [originalWarrantyClaim, setoriginalWarrantyClaim] = useState([]) 
  const getreceivedwarranty = async () => {
    try {
      await fetch(`${process.env.REACT_APP_PROD_URL}/ColorBotGetWarrantyClaim`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${window.localStorage.getItem('token')}`
        }
      }).then((res) => res.json()).then((response) => {
        if (response.status === 200) {
          setwarranty(response.data)
          setoriginalWarranty(response.data) 
        } else {
          setwarranty([])
          setoriginalWarranty([]) 
          toast.error("No Warranty Claim Raised Found")

        }
      })
    } catch (error) {
      console.error('API Error:', error);
    }

  }

  const getreceivedwarrantyClaim = async () => {
    try {
      await fetch(`${process.env.REACT_APP_PROD_URL}/ColorBotGetRaiseWarrantyClaim`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${window.localStorage.getItem('token')}`
        }
      }).then((res) => res.json()).then((response) => {
        if (response.status === 200) {
          setWarrantyClaim(response.data)
          setoriginalWarrantyClaim(response.data) 
          setModalWarrantyClaim1(true)

        } else {
          setWarrantyClaim([])
          setoriginalWarrantyClaim([]) 
          toast.error("No Warranty Claim Found")

        }
      })
    } catch (error) {
      console.error('API Error:', error);
    }

  }
  useEffect(() => {
    getreceivedwarranty()
  }, [])
  function daysLeftToNextTwoYearsFromDate(startDate) {
    const startDateObj = new Date(startDate);

    const warrantyEndDate = new Date(startDateObj);
    warrantyEndDate.setFullYear(startDateObj.getFullYear() + 4);

    const daysDifference = Math.ceil((warrantyEndDate - new Date()) / (1000 * 60 * 60 * 24));

    return daysDifference;
  }
  const search = async () => {
    if (searchvalue.length > 0) {
      const filteredData = originalWarranty.filter((item) => {
        return item.orderid.toLowerCase().includes(searchvalue.toLowerCase()) || item.phone.toLowerCase().includes(searchvalue.toLowerCase())
      })
      setwarranty(filteredData)
      setCurrentPage(1)
    } else {
      setwarranty(originalWarranty)
      setCurrentPage(1)
    }
  }

  const searchClaim = async () => {
    if (searchclaimvalue.length > 0) {
      const filteredData = originalWarrantyClaim.filter((item) => {
        return item.TicketId.toLowerCase().includes(searchclaimvalue.toLowerCase()) || item.orderId.toLowerCase().includes(searchclaimvalue.toLowerCase())
      })
      setWarrantyClaim(filteredData)
    } else {
      setWarrantyClaim(originalWarrantyClaim)
    }
  }

  const onKeyDown = (e) => {
    if (e.target.value.length < 1) {
      setWarrantyClaim(originalWarrantyClaim)
    }
  }

  const updateWarrantyStatus = async (id, warranty = "") => {

    await fetch(`${process.env.REACT_APP_PROD_URL}/ColorBotUpdateWarrantyStatus`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${window.localStorage.getItem('token')}`
      },
      body: JSON.stringify({
        "status": "Done",
        "TicketId": id ? id : "",
        "warrantyid": warranty ? warranty : ""

      })
    }).then((res) => res.json()).then((response) => {

      if (response.status === 200) {
        toast.success(response.message)

        getreceivedwarranty()

      } else {
        toast.error(response.message)

      }


    }).catch((error) => {
      console.error('API Error:', error);

    })

  }
  const createdWarrantyticket = async () => {
    setLoader(true)
    await fetch(`${process.env.REACT_APP_PROD_URL}/ColorRaiseWarrantyClaim`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${window.localStorage.getItem('token')}`
      },
      body: JSON.stringify({
        "orderId": warranty[warrantyIndex].orderid,
        "name": warranty[warrantyIndex].name,
        "email": warranty[warrantyIndex].email,
        "phone": warranty[warrantyIndex].phone,
        "description": warrantyDescription,
        "itemNo": warranty[warrantyIndex].itemno,
        "dateOfPurchase": warranty[warrantyIndex].date,
        "dateOfClaim": warranty[warrantyIndex].createdAt,
        "warrantyid": warranty[warrantyIndex].warrantyid,
        "status": "Pending"

      })
    }).then((res) => res.json()).then((response) => {

      if (response.status === 200) {
        toast.success(response.message)
        setModalWarrantyClaim2(false)
        setWarrantyDescription("")
        setWarrantyIndex(0)
        getreceivedwarranty()
        setLoader(false)
      } else {
        toast.error(response.message)
        setLoader(false)
      }


    }).catch((error) => {
      console.error('API Error:', error);
      setLoader(false)
    })

  }

  const printTicket = async (id) => {

    const elementToCapture = document.getElementById(id);

    await html2pdf(elementToCapture)
      .then(pdf => {
        pdf.save("warranty.pdf");

      })
      .catch(error => {
        console.error('Error converting element to PDF:', error);
      });

  }

  const status = async (status) => {
    let dataToFilter = searchvalue.length > 0 ? 
      originalWarranty.filter((item) => {
        return item.orderid.toLowerCase().includes(searchvalue.toLowerCase()) || 
               item.phone.toLowerCase().includes(searchvalue.toLowerCase())
      }) : 
      [...originalWarranty];
      
    if (status === "Pending") {
      const filteredData = dataToFilter.filter((item) => {
        return item.status === "Pending"
      })
      setwarranty(filteredData)
    } else if (status === "Done") {
      const filteredData = dataToFilter.filter((item) => {
        return item.status === "Done"
      })
      setwarranty(filteredData)
    } else {
      if (searchvalue.length > 0) {
        search();
      } else {
        setwarranty(originalWarranty);
      }
    }
    setCurrentPage(1)
  }
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(20); 

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = warranty.slice(indexOfFirstItem, indexOfLastItem);

  const nextPage = () => {
    setCurrentPage((prevPage) => prevPage + 1);
  };

  const prevPage = () => {
    setCurrentPage((prevPage) => prevPage - 1);
  };

  const goToPage = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const filterClaim = async (date) => {
    setEndDate(date)
    if (startDate && date) {
      await fetch(`${process.env.REACT_APP_PROD_URL}/ColorBotAdminGetWarrantyClaimByDate`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${window.localStorage.getItem('token')}`
        },
        body: JSON.stringify({
          "startdate": startDate,
          "enddate": date
        })
      }).then((res) => res.json()).then((response) => {
        if (response.status === 200) {
          setwarranty(response.data)
          setoriginalWarranty(response.data) 
        } else {
          setwarranty([])
          setoriginalWarranty([]) 
          toast.error("No Warranty Claim Raised Found")

        }
      })
    } else {
      toast.error("Please Select Date", {
        position: toast.POSITION.TOP_RIGHT
      })
    }
  }
  
  const refreshData = async () => {
    setsearchvalue("");
    await getreceivedwarranty();
    setCurrentPage(1);
    setStartDate("");
    setEndDate("");
    toast.success("Data refreshed successfully");
  }
  return (
    <>
      <section className="dashbg-color">
        <div className="row justify-content-center">
          <div className="col-lg-12">
            <div className="admin-filters">

              <div className="search-bar">
                <div className="search-container">
                  <form action="">
                    <input type="text" placeholder="Search by- Order ID, Phone" name="search" value={searchvalue} onChange={(e) => {
                      setsearchvalue(e.target.value)
                      if (e.target.value === '') {
                        setwarranty(originalWarranty)
                        setCurrentPage(1)
                      }
                    }} />
                    <button type="button" onClick={() => {
                      search()
                    }}><i className="fa fa-search"></i></button>
                  </form>
                </div>
              </div>

              <div className="filters d-flex">
                

                <div className="dash-filters">
                  <button className="btn filter-pop " style={{ margin: "" }} onClick={() => {
                    getreceivedwarrantyClaim()
                  }}>Raised Ticket </button>
                  <input className="strt-date" type="date" placeholder="Start Date" value={startDate} onChange={(e) => {
                    setStartDate(e.target.value);
                    filterClaim(endDate)
                  }} />



                  <input className="end-date" type="date" placeholder="End Date" value={endDate} onChange={(e) => {
                    filterClaim(e.target.value)
                  }} />
                  <Dropdown className="" style={{ margin: "" }}>
                    <Dropdown.Toggle id="dropdown-autoclose-true" className="btn filter-pop m-1" >Status <i className="fa fa-angle-down"></i>
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      <Dropdown.Item onClick={() => {
                        status("Done")
                      }}>Resolved</Dropdown.Item>
                      <Dropdown.Item onClick={() => {
                        status("Pending")
                      }}>Unresolved</Dropdown.Item>
                      <Dropdown.Item onClick={() => {
                        status("All")
                      }}>All</Dropdown.Item>

                    </Dropdown.Menu>
                  </Dropdown>

                  <button className="btn filter-pop ml-2" style={{ backgroundColor: "white", color: "#4CAF50", borderColor:"#4CAF50" }} onClick={refreshData}>
                   <i className="fas fa-sync-alt"></i>
                </button>
                </div>


              </div>

            </div>
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-lg-12 table-bg">
            <div style={{ backgroundColor: "white" }}>
              <div className="table-responsive">
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th scope="col">S.No.</th>
                      <th scope="col">Order ID</th>
                      <th scope="col">Item No.</th>
                      <th scope="col">Model Type</th>
                      <th scope="col">Platform</th>
                      <th scope='col'>Description</th>
                      <th scope="col">Name</th>
                      <th scope="col">Phone</th>
                      <th scope="col">Email</th>
                      <th scope="col">Address</th>
                      <th scope="col">Date of Purchase</th>
                      <th scope='col'>Date of Claim</th>
                      <th scope="col">Warranty Left</th>
                      <th scope="col">Invoice</th>
                      <th scope='col'>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentItems.length > 0 ? currentItems.map((item, index) => {
                      return (
                        <tr>
                          <th scope="row">{index + 1}</th>
                          <td>#{item.orderid}</td>
                          <td>{item.itemno}</td>
                          <td>{item.modal}</td>
                          <td>{item.platform}</td>
                          <td>{item.description}</td>
                          <td>{item.name}</td>
                          <td>{item.phone}</td>
                          <td>{item.email}</td>
                          <td>{item.address}</td>
                          <td>{moment(item.date).format("DD MMM, YYYY")}</td>
                          <td>{moment(item.createdAt).format("DD MMM, YYYY")}</td>
                          <td>{daysLeftToNextTwoYearsFromDate(item.date) > 0 ? daysLeftToNextTwoYearsFromDate(item.date) + " days" : "Expired"} </td>
                          <td><a href={item.file} target="_blank"><img src="assets/downloadbtn.svg" /></a></td>
                          <td><div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                            {item?.status === "Pending" ? <button className='resolve' onClick={() => {
                              updateWarrantyStatus(item?.TicketId,item.warrantyid)
                            }}>Resolve</button> : <button className='unresolve'>Resolved</button>}

                            {!item.TicketId ? <button className='raisedticket' onClick={() => {
                              setModalWarrantyClaim2(true);
                              setWarrantyIndex(index);
                              setWarrantyDescription("")
                            }}>Raise Ticket</button> : ""}
                          </div></td>
                        </tr>
                      )
                    }) : <tr><td colSpan="14" className="text-center">No Warranty Claim Found</td></tr>
                    }


                  </tbody>
                </table>
              </div>



              {currentItems.length > 0 ? <div className="row">
                <div className="col-lg-12 text-center" style={{ position: "relative" }}>
                  <div className="pagination pagi">
                    {currentPage === 1 ? "" : <a href="javascript:void(0)" onClick={prevPage} disabled={currentPage === 1}>&laquo;</a>}

                    {Array.from({ length: Math.ceil(warranty.length / itemsPerPage) }).map((_, index) => (
                      <a href="javascript:void(0)" key={index}
                        onClick={() => goToPage(index + 1)}
                        className={currentPage === index + 1 ? "active" : ""}>{index + 1}</a>
                    ))}
                    {currentPage === Math.ceil(warranty.length / itemsPerPage) ? "" : <a href="javascript:void(0)" onClick={nextPage}
                      disabled={currentPage === Math.ceil(warranty.length / itemsPerPage)}>&raquo;</a>}
                  </div>
                  <div className="table-no-count">
                    Showing {Math.min(indexOfLastItem, warranty.length)} of {warranty.length} results
                  </div>
                </div>
              </div> : ""}
            </div>
          </div>
        </div>

        <Modal show={modalWarrantyClaim1}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header style={{ padding: "0px" }}>

            <div className='ticket-raised-header'>
              <div className="title m-0 p-0">
                <h3 className="p-3 m-0">Raised Tickets</h3>
                <button className="btn filter-pop" onClick={() => {
                  setModalWarrantyClaim1(false);
                  setsearchclaimvalue("")
                }}><i className="fa fa-xmark"></i></button>
              </div>
            </div>

          </Modal.Header>

          <Modal.Body>

            <div className="ticket-raised-body">
              <div className="row">
                <div className='col-lg-12'>
                  <div className="search-bar">
                    <div className="search-container d-flex justify-content-center" style={{ width: "100%" }}>
                      <form action="">
                        <input type="text" style={{ width: "556px" }} placeholder="Search by- Order ID, Ticket ID" onKeyDown={onKeyDown} name="search" value={searchclaimvalue} onChange={(e) => {
                          setsearchclaimvalue(e.target.value)
                          if (e.target.value === '') {
                            setWarrantyClaim(originalWarrantyClaim)
                          }
                        }} />
                        <button type="button" onClick={() => {
                          searchClaim()
                        }}><i className="fa fa-search"></i></button>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
              {warrantyClaim.length > 0 && warrantyClaim.map((item, index) => (
                <div className="row content1 p-2 mt-5 mb-3" key={index} id={`printwallet${index}`}>
                  <div className="  col-lg-12 p-2 d-flex justify-content-between">
                    <div className="left-cntnt">
                      <div className="input-box d-flex justify-content-between gapAdd">
                        <span className="details">Ticket ID:</span>
                        <span>{item?.TicketId}</span>
                      </div>
                      <div className="input-box d-flex justify-content-between gapAdd">
                        <span className="details">Order ID:</span>
                        <span>{item?.orderId}</span>
                      </div>
                      <div className="input-box d-flex justify-content-between gapAdd">
                        <span className="details">Item No:</span>
                        <span>{item?.itemNo}</span>
                      </div>
                      <div className="input-box d-flex justify-content-between gapAdd">
                        <span className="details">Date of Purchase:</span>
                        <span>{moment(item?.dateOfPurchase).format("DD MMM, YYYY")}</span>
                      </div>
                      <div className="input-box d-flex justify-content-between gapAdd">
                        <span className="details">Date of Claim:</span>
                        <span>{moment(item?.dateOfClaim).format("DD MMM, YYYY")}</span>
                      </div>
                    </div>
                    <div className="right-cntnt">
                      <div className="d-flex  justify-content-between gapAdd">
                        <div className="left d-flex justify-content-between gapAdd">
                          <span className="details">Name:</span>
                          <span>{item?.name}</span>
                        </div>
                        <div className="right d-flex justify-content-between gapAdd" id='notprint'>
                          <span className="print" id='notprint' onClick={() => {
                            printTicket(`printwallet${index}`)

                          }}><img className="mb-1" id='notprint' src="./assets/print.svg" alt="" /></span>
                        </div>
                      </div>
                      <div className="input-box d-flex justify-content-between gapAdd">
                        <span className="details">Phone:</span>
                        <span>{item.phone}</span>
                      </div>
                      {/* <div className="input-box">
                       <span class="details">Address:</span>
                       <span>Plot-231, Sahibabad, Ghaziabad</span>
                     </div>
                     <div className="input-box">
                       <span className="details">State</span>
                       <span>Uttar Pradesh</span>
                     </div>
                     <div className="input-box">
                       <span className="details">Pin Code.</span>
                       <span>201010</span>
                     </div> */}
                    </div>
                  </div>
                  <div className="textarea">
                    <div className="">
                      <label for="exampleFormControlTextarea1" className="form-label details">Message</label>
                      <textarea className="form-control" id="exampleFormControlTextarea1" rows="3" placeholder="Description" value={item?.description} readOnly></textarea>
                    </div>
                  </div>
                </div>
              ))}

            </div>
          </Modal.Body>

        </Modal>
        <Modal show={modalWarrantyClaim2}

          aria-labelledby="contained-modal-title-vcenter"
          centered
        >


          <Modal.Body>
            <div className="raise-claim-body">
              <div className="raise-claim-header text-center ">
                <h2>Add details for this Complain.</h2>
              </div>
              <textarea placeholder="Description" className="raise-claim" required value={warrantyDescription} onChange={(e) => {
                setWarrantyDescription(e.target.value)
              }}></textarea>
              <div className=" d-flex justify-content-center">
                <div className='Buton'>
                  <button type="submit" className="btn1" onClick={() => {
                    setModalWarrantyClaim2(false);
                    setWarrantyDescription("")
                  }}>Cancel</button>
                  <button type="button" className=" btn2 " disabled={loader} onClick={() => {
                    createdWarrantyticket()
                  }}>Add</button>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </section>
    </>
  )
}
export default WarrantyClaim;